import React, { useState } from 'react';
import styled from 'styled-components';
import { isMobile, isTablet } from 'react-device-detect';
import ReactPlayer from 'react-player'

import { DownArrow } from '../DownArrow';


const Wrapper = styled.div`
  height: auto;
  width: 100vw;
  display: flex;
  min-height: 650px;
  flex-direction: row;

  @media only screen and (min-width: 769px) {
    height: calc(100vh - ${props => props.includeBanner ? 130 : 80}px);
  }
`;

const Overlay = styled.div`
  background-color: var(--black);
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  @media only screen and (min-width: 769px) {
    min-height: 700px;
  }
`

const TextContainer = styled.div`
  padding: 0 40px;
  position: absolute;
  padding-top: 20vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  @media only screen and (min-width: 769px) {
    padding: 0 80px;
    padding-top: 160px;
    width: 620px;
    display: block;
    text-align: left;
  }
`;

const DownArrowContainer = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-items: center;
`

const Background = styled.div`
  width: 100%;
  height: 100vh;
  background: url(${props => props.src}) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
`

export const OpeningVideoPanel = ({textChildren, includeBanner, transparentHeader, videoUrl, photoUrl, backupImg=false, overlay=false}) => {
  const [light, setLight] = useState(photoUrl);
  const coreHeight = isMobile ? 60 : 80
  const wrapperAdjustment = coreHeight + includeBanner ? 50 : 0 + transparentHeader ? -coreHeight : 0;

  return (
    <Wrapper style={isMobile ? {flexDirection: 'column'} : {paddingTop: wrapperAdjustment, height: `calc(100vh - ${wrapperAdjustment}px)`}}>
      { isMobile || isTablet ?
        <Background src={backupImg || photoUrl} />
        :
        light &&
        <Background src={light} />
       }
      <div style={light ? {display: 'none'} : {}}>
      <ReactPlayer url={videoUrl} onReady={isMobile ? f=> f : () => setLight(false)}
          playing volume={0} muted playsinline
          loop={true} width={"100vw"}
          height={isMobile ? "100vh" : `calc(100vh - ${wrapperAdjustment})px`}
          style={{objectFit: 'cover'}}
          config={{ file: { attributes: {
            autoPlay: true,
            muted: true,
            playsinline: true,
            autobuffer: true
          }}}}
          />
      </div>
      {overlay && <Overlay  />}
      <TextContainer>
        {textChildren}
      </TextContainer>
      <DownArrowContainer>
        <DownArrow />
      </DownArrowContainer>
    </Wrapper>
  );
};
